import { EventEmitter, OnDestroy, OnInit } from '@angular/core';
import { SearchQuery } from '../models/search-query.model';
import { UniversityFinderFilter, UNIVERSITY_DEGREE_OPTIONS, UNIVERSITY_MAJOR_OPTIONS, UNIVERSITY_ACCREDITATION_OPTIONS, UNIVERSITY_OPTION_OPTIONS } from '../../shared/models/university-finder-filter.model';
import { UniversityFinderFiltersService } from '../../shared/services/university-finder-filters.service';
import { AnalyticsService } from '../../airport/service/google-analytics-4.service';
/**
 * Filter UI for the University Finder, mirroring {@link FlyingClubFinderFilterListComponent}. Renders a
 * keyword field plus the Degrees / Majors / Accreditation / Additional facet groups (all AND logic). Reads
 * and writes the shared {@link UniversityFinderFiltersService} state and emits `filtersChange`.
 */
var UniversityFinderFilterListComponent = /** @class */ (function () {
    function UniversityFinderFilterListComponent(_universityFinderFiltersService, _analyticsService) {
        this._universityFinderFiltersService = _universityFinderFiltersService;
        this._analyticsService = _analyticsService;
        this.filtersChange = new EventEmitter();
        this.degreeOptions = UNIVERSITY_DEGREE_OPTIONS;
        this.majorOptions = UNIVERSITY_MAJOR_OPTIONS;
        this.accreditationOptions = UNIVERSITY_ACCREDITATION_OPTIONS;
        this.optionOptions = UNIVERSITY_OPTION_OPTIONS;
        this.universityFinderFilter = new UniversityFinderFilter();
    }
    Object.defineProperty(UniversityFinderFilterListComponent.prototype, "nameTooShort", {
        /**
         * True when a university name has been entered but is too short to count toward a search. Mirrors the
         * `universityKeyword.length >= 3` gate in {@link SearchQuery.validate}, so the hint shows exactly while the
         * entered name would be ignored.
         */
        get: function () {
            var trimmed = this.universityFinderFilter.name ? this.universityFinderFilter.name.trim() : '';
            return trimmed.length > 0 && trimmed.length < 3;
        },
        enumerable: true,
        configurable: true
    });
    UniversityFinderFilterListComponent.prototype.ngOnInit = function () {
        var _this = this;
        this._subscription = this._universityFinderFiltersService.universityFinderFilter.subscribe(function (f) {
            _this.universityFinderFilter = f;
        });
        this._analyticsService.pageView('airport_landingpage_university', 'University Finder Landing Page filters');
    };
    UniversityFinderFilterListComponent.prototype.ngOnDestroy = function () {
        if (this._subscription) {
            this._subscription.unsubscribe();
        }
    };
    UniversityFinderFilterListComponent.prototype.isFacetSelected = function (group, value) {
        return this.universityFinderFilter[group].indexOf(value) !== -1;
    };
    UniversityFinderFilterListComponent.prototype.onToggleFacet = function (group, value, checked) {
        var selected = this.universityFinderFilter[group];
        var i = selected.indexOf(value);
        if (checked && i === -1) {
            selected.push(value);
        }
        else if (!checked && i !== -1) {
            selected.splice(i, 1);
        }
        this._emit();
    };
    UniversityFinderFilterListComponent.prototype.onSelectAll = function (group, options) {
        this.universityFinderFilter[group] = options.map(function (o) { return o.value; });
        this._emit();
    };
    UniversityFinderFilterListComponent.prototype.onClearAll = function (group) {
        this.universityFinderFilter[group] = [];
        this._emit();
    };
    UniversityFinderFilterListComponent.prototype.onNameChange = function () {
        this._emit();
    };
    UniversityFinderFilterListComponent.prototype._emit = function () {
        // Keep the query's filter in sync as the user edits, so a university name entered here counts toward
        // search validation (see SearchQuery.validate) even before the query is serialized/submitted.
        if (this.query) {
            this.query.universityFinderFilter = this.universityFinderFilter;
        }
        this._universityFinderFiltersService.updateUniversityFinderFilters(this.universityFinderFilter);
        this.filtersChange.emit();
    };
    return UniversityFinderFilterListComponent;
}());
export { UniversityFinderFilterListComponent };
